module.exports = __webpack_public_path__ + "static/img/manual_ja_19.7f34d01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_19.png
// module id = 07Lc
// module chunks = 4